/* eslint-disable @typescript-eslint/naming-convention -- campos em snake_case espelham o contrato da API */
export enum EnumAttachmentErrorCode {
  MISSING_IDEMPOTENCY_KEY = 'missing_idempotency_key',
  NOT_FOUND = 'attachment_not_found',
  IDEMPOTENCY_CONFLICT = 'idempotency_conflict',
  NOT_READY = 'attachment_not_ready',
  FAILED = 'attachment_failed',
  DELETED = 'attachment_deleted',
  EXPIRED = 'attachment_expired',
  TOO_LARGE = 'attachment_too_large',
  INPUT_TOO_LARGE = 'attachment_input_too_large',
  CONTEXT_TOO_LARGE = 'attachment_context_too_large',
  TYPE_UNSUPPORTED = 'attachment_type_unsupported',
  VALIDATION_ERROR = 'validation_error',
  QUOTA_EXCEEDED = 'knowledge_quota_exceeded',
  UNAVAILABLE = 'attachment_unavailable',
  SOURCE_UNAVAILABLE = 'attachment_source_unavailable',
  DOCUMENT_CORRUPT = 'document_corrupt',
  PAGE_LIMIT_EXCEEDED = 'page_limit_exceeded',
  MULTIFRAME_UNSUPPORTED = 'attachment_multiframe_unsupported'
}
